import React, { useEffect, useState, startTransition } from 'react';
import useSelector, { useDispatch } from 'components/Booking-new/hooks';

import { pushGTMBookingCancelledEvent, pushGTMUpdateBookingDisplayedEvent } from 'utils/gtm';
import pushGTMWithDelay from 'utils/pushGTMWithDelay';
import stepTypes from 'components/Booking-new/modules/Steps/types';
import { getServiceData } from 'components/Booking-new/utils/steps/service';
import bookingService from 'components/Booking-new/services/BookingService';
import { getBookingData } from 'components/Booking-new/utils/steps/summary';
import { resetBooking } from '../../../actions';
import { refreshToken } from '../../../utils/helpers/refreshToken';
import getURLParameter from '../../../../../utils/getURLParams';
import { getVisitsOnLocalStorage } from '../../../../../utils/bas/getVisitsOnLocalStorage';

const RescheduleContainer = (Component, { data, navigation }) => {
  const dispatch = useDispatch();
  const goToNextStep = () => navigation.goToNextStep();
  const { results, state } = useSelector(state => ({
    userData: {
      locationCode: state?.userData[stepTypes.location]?.selectedLocation?.code,
      time: state?.userData[stepTypes.time]?.time,
      appointmentStatus: state?.userData[stepTypes.reschedule]?.appointment?.appointmentstatus,
      service: state?.userData[stepTypes.reschedule]?.service.service,
      stepPersonalData: state?.userData[stepTypes.personalData],
    },
    config: {
      service: state?.config?.service,
      serviceName: state?.config?.service?.name,
      showNewsBanner: state?.config?.showNewsBanner,
    },
    allServices: state?.services,
    funnelType: state?.config?.funnelType,
  }));

  const allServices = results?.allServices.nodes;
  const serviceCode = results?.userData.service;

  const [selectedReason, setSelectedReason] = useState('');
  const handleReasonChange = event => {
    setSelectedReason(event.target.value);
  };

  const cancelBooking = async () => {
    const stateConfig = { ...state.config, service: { ...state.config.service, code: serviceCode } };
    const body = getBookingData({
      ...state,
      config: stateConfig,
    });

    const changeSource = getURLParameter('change-source');
    const newToken = await refreshToken();

    let additionalBodyProps = {};
    const visits = [];
    getVisitsOnLocalStorage(visits);
    if (localStorage.getItem('user-anom-id')) additionalBodyProps.anom_id = localStorage.getItem('user-anom-id');
    if (visits.length > 0) additionalBodyProps.visits = visits;

    return bookingService
      .saveBooking(
        {
          ...body,
          saction: 'CANCEL',
          cancel_reason: selectedReason,
          change_source: changeSource,
          ...additionalBodyProps,
        },
        newToken,
      )
      .then(response => {
        const { data, error } = response;
        if (data && !error) {
          startTransition(() => {
            dispatch(resetBooking());
          });
          pushGTMBookingCancelledEvent({
            location: data.location,
            service: data.service,
            cancelReason: selectedReason,
          });
        } else {
          dispatch({ type: 'ERROR_IN_CANCELLATION' });
        }
        return response;
      })
      .catch(() => {
        dispatch({ type: 'ERROR_IN_CANCELLATION' });
      });
  };

  useEffect(() => {
    // trigger GTM event "Update Booking Displayed"
    pushGTMWithDelay(33, pushGTMUpdateBookingDisplayedEvent, {
      location: results?.userData?.locationCode,
      service: results?.userData.service,
      funnelType: results?.funnelType,
    });
  }, []);

  const stepRescheduleComponentData = {
    stepRescheduleCF: { ...data, selectedReason },
    handleReasonChange,
    userData: results?.userData,
    service: results?.config.service,
    serviceName: getServiceData(allServices, serviceCode)?.name,
    showNewsBanner: results?.config?.showNewsBanner,
    goToNextStep,
    cancelBooking,
  };

  return <Component {...stepRescheduleComponentData} />;
};

export default RescheduleContainer;
